import React from 'react';
import ReactMarkdown from 'react-markdown';
import { graphql, Link } from "gatsby";
import { GatsbyImage } from 'gatsby-plugin-image';

import Layout from '../../components/Layout';
import ChevronDown from '../../images/chevron-down.svg';

const BlogPage = ({data}) => {
  const post = data.strapiBlogPost;

  return (
    <Layout title={post.Title}>
      <div className="py-8 bg-white">
        <div className="container mx-auto px-12">
          <Link to="/blog" className="font-semibold hover:text-orange transition">
            <img className="inline mr-2 transform rotate-90" src={ChevronDown} alt="" />
            Back to blog
          </Link>
          <h2 className="mt-4 text-xl font-semibold">{post.Title}</h2>
          <p className="pb-2 mt-4 mb-8 text-orange text-md font-semibold border-b-8 border-orange">{post.BlogCategory.Title}</p>
          <GatsbyImage image={post.CoverImage.localFile.childImageSharp.gatsbyImageData} alt={post.CoverImage.alternativeText} />
          <p className="italic text-lg mt-4 mb-2">{post.Author.Name}, {post.updated_at}</p>
          {post.Labels.length > 0 && (
            <ul className="mt-2 flex">
              {post.Labels.map(label => (
                <li key={label.Slug} className="mx-4 first:ml-0 last:mr-0 text-md border-b border-gray-darkest text-gray-darkest">{label.Title}</li>
              ))}
            </ul>
          )}
          <div className="mt-12 mb-8 prose max-w-5xl">
            <ReactMarkdown children={post.Content} />
          </div>
        </div>
      </div>
    </Layout>
  );
}

export const query = graphql`
  query BlogPostQuery($Slug: String) {
    strapiBlogPost(Slug: {eq: $Slug}) {
      Slug
      Title
      Author {
        Slug
        Name
      }
      BlogCategory {
        Title
        Slug
      }
      Labels {
        Title
        Slug
      }
      updated_at(formatString: "dddd, MMMM Do YYYY")
      CoverImage {
        alternativeText
        localFile {
          childImageSharp {
            gatsbyImageData
          }
        }
      }
      Content
    }
  }
`;

export default BlogPage;